import { render, staticRenderFns } from "./city-add.vue?vue&type=template&id=461975b4&scoped=true&"
import script from "./city-add.vue?vue&type=script&lang=js&"
export * from "./city-add.vue?vue&type=script&lang=js&"
import style0 from "./city-add.vue?vue&type=style&index=0&id=461975b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461975b4",
  null
  
)

export default component.exports